// Company definitions for the multi-company (Teleborsa srl / S.I.T. srl) split.
export const COMPANIES = {
  teleborsa: {
    code: "teleborsa",
    label: "Teleborsa srl",
    short: "Teleborsa",
    tagline: "Informazione e mercati finanziari",
    accent: "#e30613",
    logo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_245f66f2-f40f-4d0d-bf0c-2f5a034db31b/artifacts/a3si4vpo_001logo_1773327433image.png",
  },
  sit: {
    code: "sit",
    label: "S.I.T. srl",
    short: "S.I.T.",
    tagline: "Società Italiana Teletrasmissioni",
    accent: "#3f66b3",
    logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_finance-grid-4/artifacts/9e0x66u0_logo%20sit.jpg",
  },
};

export const COMPANY_LIST = Object.values(COMPANIES);
export const SELECTED_COMPANY_KEY = "tb_selected_company";
export const HEADER_COMPANY_KEY = "tb_header_company";
const DYNAMIC_COMPANIES_KEY = "tb_dynamic_companies";

// Aziende (tenant) create dal Superadmin: risolte dinamicamente oltre a quelle predefinite.
export const cacheDynamicCompanies = (list) => {
  try { sessionStorage.setItem(DYNAMIC_COMPANIES_KEY, JSON.stringify(list || [])); } catch { /* noop */ }
};
export const getDynamicCompanies = () => {
  try { return JSON.parse(sessionStorage.getItem(DYNAMIC_COMPANIES_KEY) || "[]"); } catch { return []; }
};
export const resolveCompany = (code) => {
  if (!code) return null;
  if (COMPANIES[code]) return COMPANIES[code];
  const d = getDynamicCompanies().find((c) => c.code === code);
  if (!d) return null;
  const logo = d.has_logo ? `${process.env.REACT_APP_BACKEND_URL}/api/companies/${d.code}/logo` : null;
  return { code: d.code, label: d.label, short: d.short || d.label, tagline: d.tagline || "", accent: d.accent || "#0d6cb8", logo, dynamic: true };
};

export const companyLabel = (code) => COMPANIES[code]?.label || (resolveCompany(code)?.label) || "Teleborsa srl";
export const companyShort = (code) => COMPANIES[code]?.short || "Teleborsa";
export const companyLogo = (code) => COMPANIES[code]?.logo || COMPANIES.teleborsa.logo;
export const getSelectedCompany = () => {
  const c = localStorage.getItem(SELECTED_COMPANY_KEY);
  return c && resolveCompany(c) ? c : null;
};
export const setSelectedCompany = (code) => localStorage.setItem(SELECTED_COMPANY_KEY, code);
